import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from './loader.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { URLS } from '../../constants/URLS';
import { Router } from '@angular/router';
import { Logger } from '../../../../common/core/utilities/logging/logger';
import { AuthenticationService } from '../../../../common/user-management/auth-management/authentication/services/authentication.service';
import { UserContextService } from '../../../../common/user-management/auth-management/authentication/services/user-context.service';
import { environment } from '../../../../../assets/environment/environment';

const defaultConfig: Omit<RequestConfig, 'path'> = {
  useToken: true,
  isLoad: true,
};
@Injectable({
  providedIn: 'root',
})
export class RequestBaseService {
  isPswChanged: boolean = true;
  private _body: { [key: string]: any } = {};
  private _params: { [key: string]: any } = {};
  private _header: { [key: string]: any } = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  // path: string = '';

  constructor(
    private loaderService: LoaderService,
    protected http: HttpClient,
    public translate: TranslateService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  // public setPath(path: string): void {
  //   this.path = path;
  // }
  // public getPath(): string {
  //   return environment.apiUrl + this.path;
  // }
  // public setParams(params: { [key: string]: any }): void {
  //   this._params = params;
  // }
  public prepareParams(
    param: any,
    config: { isString: boolean } = { isString: true }
  ): any {
    if (config.isString) {
      let parames = '';
      let keys = Object.keys(param);
      if (keys.length > 0) {
        parames = '?';
        for (let index = 0; index < keys.length; index++) {
          const key = keys[index];
          if (param[key] instanceof Array) {
            for (let i = 0; i < param[key].length; i++) {
              let item = param[key][i];
              parames += `${key}[${i}]=${item}`;
              if (i < param[key].length - 1) parames += '&';
            }
          } else {
            parames += `${key}=${param[key]}`;
          }
          if (index < keys.length - 1) parames += '&';
        }
      }
      return parames;
    } else return param;
  }
  // public setHeader(header : {[key : string] : any}) : void {
  //   this._header = {
  //     ...header,
  //   };
  // }
  public getHeaders(
    config: RequestConfig,
    setType: boolean = true
  ): HttpHeaders {
    // Logger.debug(this.translate.currentLang)
    let header: any = { lang: this.translate.currentLang };
    if (setType) {
      header = { ...this._header, ...header };
    }

    let token = this.authService.ensureAuthenticated();

    if (config.useToken ?? true) {
      header = {
        ...header,
        authorization: `Bearer ${token?.accessToken}`,
      };
    }
    // Logger.debug('header', header);
    return new HttpHeaders(header);
  }

  public setBody(body: { [key: string]: any }): void {
    this._body = body['data'];
  }
  public getBody(): { [key: string]: any } | FormData {
    return this._body;
  }
  preProcessResponse(response: any, path: string) {
    if (response.code == '111') {
      this.loaderService._isLoading.next(false);
      if (location.href.indexOf('/expire/password') == -1)
        this.router.navigate(['/expire/password']);
      return response;
    }

    switch (response.status) {
      case 404:
        break;
      case 401:
        //logout logic
        if (path != URLS.LOGOUT && !UserContextService.isAuthenticated())
          this.authService.logout();
        break;
      case 403:
        break;
      case 422:
        response = { status: false, status_code: 422, ...response.error };
        break;
      case 400:
        response = { status: false, ...response.error };
        break;
      case 460:
        throw { validationErrors: response };
      case 500:
      case 501:
      case 502:
      case 504:
        break;
      case 503:
        this.router.navigate(['/error/503']);
        break;
      default:
        break;
    }
    this.loaderService._isLoading.next(false);
    return response;
  }

  hasLoader(config: RequestConfig) {
    this.loaderService._isLoading.next(config.isLoad ?? true);
  }
  getOldDAta(config: RequestConfig) {
    // if (config.useOldData) {
    //   const oldDataDAte = this.userData.getData(config.useOldData + '_date');
    //   if (oldDataDAte) {
    //     let date = new Date(oldDataDAte);
    //     if (date.getTime() > new Date().getTime()) {
    //       return JSON.parse(this.userData.getData(config.useOldData) ?? '{}');
    //     }
    //   }
    // }
    // const params = this.prepareParams(config.params ?? {});
    return this.prepareParams(config.params ?? {});

    // return this.httpCachingService.getCachedData(config.path + params);
  }

  /**
   * Attempts to call the `_makeRequest()` method that is implemented
   * by other classes.
   *
   * @return Promise
   */
  async send(response: Promise<any>, config: RequestConfig): Promise<any> {
    let res, rej;

    try {
      res = await response;
      res = this.preProcessResponse(res, config.path);
      // if (useOldData && minutes) {
      //   this.userData.setData(useOldData, JSON.stringify(res));
      //   let dateNow = new Date().getTime() / (1000 * 60) + minutes;
      //   let date = new Date(dateNow * 60000);
      //   this.userData.setData(useOldData + '_date', `${date}`);
      // }
      const params = this.prepareParams(config.params ?? {});
      // this.httpCachingService.setCachedData(config.path + params, res);
    } catch (err) {
      rej = this.preProcessResponse(err, config.path);
    }

    if (res) {
      return Promise.resolve(res);
    } else if (rej) {
      return Promise.reject(rej);
    }
  }
  getPreDate(config: RequestConfig) {
    const oldData = this.getOldDAta(config);
    this.hasLoader(config);
    const path = config.path;
    const params = this.prepareParams(config.params ?? {});
    return { path, params, oldData };
  }

  prepareConfig(config: RequestConfig) {
    if (config.isLoad == undefined) config.isLoad = true;
    if (config.useToken == undefined) config.useToken = true;

    return config;
  }

  async put(config: RequestConfig): Promise<any> {
    config = this.prepareConfig(config);
    const preparedDate = this.getPreDate(config);
    if (preparedDate.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedDate.oldData;
    }
    const body = this.getBody();
    const headers = this.getHeaders(config, !(body instanceof FormData));
    try {
      // Makes a PUT request to the provided `path` with the attached `headers` and `params`.
      const response = lastValueFrom(
        this.http.put(
          environment.apiUrl + preparedDate.path + preparedDate.params,
          body,
          { headers }
        )
      );
      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      return this.send(response, config);
    } catch (err) {
      return this.preProcessResponse(err, config.path);
    }
  }

  async post(config: RequestConfig): Promise<any> {
    // const oldData = this.getOldDAta(config);
    // if (oldData) return oldData;
    // this.hasLoader(config);
    // const path = this.getPath();
    // const params = this.getParams();
    config = this.prepareConfig(config);

    const preparedDate = this.getPreDate(config);
    if (preparedDate.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedDate.oldData;
    }
    const body = this.getBody();
    const headers = this.getHeaders(config, !(body instanceof FormData));

    try {
      Logger.debug(headers.get('Accept'));

      // Makes a POST request to the provided `path` with the attached `headers` and `params`.
      const response = lastValueFrom(
        this.http.post(
          environment.apiUrl + preparedDate.path + preparedDate.params,
          body,
          { headers }
        )
      );

      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      return this.send(response, config);
    } catch (err) {
      return this.preProcessResponse(err, config.path);
    }
  }

  async get(config: RequestConfig): Promise<any> {
    config = this.prepareConfig(config);

    const preparedDate = this.getPreDate(config);
    if (preparedDate.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedDate.oldData;
    }
    const headers = this.getHeaders(config);

    try {
      // Makes a GET request to the provided `path` with the attached `headers` and `params`.
      const response = lastValueFrom(
        this.http.get(
          environment.apiUrl + preparedDate.path + preparedDate.params,
          { headers }
        )
      );

      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      return this.send(response, config);
    } catch (err) {
      return this.preProcessResponse(err, config.path);
    }
  }

  async delete(config: RequestConfig): Promise<any> {
    config = this.prepareConfig(config);

    const preparedDate = this.getPreDate(config);
    if (preparedDate.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedDate.oldData;
    }
    const headers = this.getHeaders(config);

    try {
      // Makes a DELETE request to the provided `path` with the attached `headers` and `params`.
      const response = lastValueFrom(
        this.http.delete(
          environment.apiUrl + preparedDate.path + preparedDate.params,
          { headers }
        )
      );

      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      return this.send(response, config);
    } catch (err) {
      return this.preProcessResponse(err, config.path);
    }
  }

  async downlodCSV(
    type: 'post' | 'get' = 'get',
    config: RequestConfig
  ): Promise<any> {
    config = this.prepareConfig(config);

    const preparedData = this.getPreDate(config);
    if (preparedData.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedData.oldData;
    }
    this.hasLoader(config);
    const headers = this.getHeaders(config);
    const body = this.getBody();

    try {
      // Makes a DELETE request to the provided `path` with the attached `headers` and `params`.
      let response = {} as any;
      if (type === 'post') {
        response = lastValueFrom(
          this.http.post(
            environment.apiUrl + preparedData.path + preparedData.params,
            body,
            { responseType: 'arraybuffer', headers }
          )
        );
      } else if (type === 'get') {
        response = lastValueFrom(
          this.http.get(
            environment.apiUrl + preparedData.path + preparedData.params,
            { responseType: 'arraybuffer', headers }
          )
        );
      }
      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      this.downLoadFile(await response, 'Text/CSV', config.path, '.csv');
      return { status: true }; //this.send(response, config.useOldData, config.minutes);
    } catch (err) {
      this.loaderService._isLoading.next(false);
      return this.preProcessResponse(err, config.path);
    }
  }

  async downlodExcel(
    type: 'post' | 'get' = 'get',
    config: RequestConfig
  ): Promise<any> {
    config = this.prepareConfig(config);

    const preparedData = this.getPreDate(config);
    if (preparedData.oldData) {
      this.loaderService._isLoading.next(false);
      return preparedData.oldData;
    }
    const headers = this.getHeaders(config);
    const body = this.getBody();

    try {
      // Makes a DELETE request to the provided `path` with the attached `headers` and `params`.
      let response = {} as any;
      if (type === 'post') {
        response = lastValueFrom(
          this.http.post(
            environment.apiUrl + preparedData.path + preparedData.params,
            body,
            { responseType: 'arraybuffer', headers }
          )
        );
      } else if (type === 'get') {
        response = lastValueFrom(
          this.http.get(
            environment.apiUrl + preparedData.path + preparedData.params,
            { responseType: 'arraybuffer', headers }
          )
        );
      }
      // After making the request, we will pre-process the response status to take an
      // action accordingly.
      let res = await response;
      const enc = new TextDecoder('utf-8');
      const data = new Uint8Array(res);
      let jsonRes: any = {};
      try {
        jsonRes = JSON.parse(enc.decode(data));
      } catch (error) {}
      if (jsonRes?.status == false) {
        this.loaderService._isLoading.next(false);
        return jsonRes; //this.send(response, config.useOldData, config.minutes);
      } else {
        this.downLoadFile(res, 'application/ms-excel', config.path);
      }
    } catch (err) {
      Logger.debug('err', err);

      this.loaderService._isLoading.next(false);
      return this.preProcessResponse(err, config.path);
    }
  }

  downLoadFile(
    data: any,
    type: string,
    path: string,
    extention: string = '.xlsx'
  ) {
    this.loaderService._isLoading.next(false);
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download =
      path.replace(/\//g, '_') + '_' + new Date().getTime() + extention;
    anchor.href = url;
    anchor.click();
  }

  // async downLoadFileMobild(data: any, type: string, path: string, extention: string = '.xlsx') {
  //   this.loaderService._isLoading.next(false);
  //   let blob = new Blob([data], { type: type });
  //   const base64: string = await this.blobToBase64(blob);
  //   let url = window.URL.createObjectURL(blob);
  //   const newPath = path.replace(/\//g, '_') + '_' + (new Date()).getTime() + extention;
  //   const file = await Filesystem.writeFile({
  //     path: newPath,
  //     data: base64,
  //     directory: Directory.Documents,
  //     // encoding: Encoding.UTF8,
  //   });
  //   Swal.fire({
  //     toast: true,
  //     position: 'top-end',
  //     showConfirmButton: false,
  //     timer: 5000,
  //     timerProgressBar: true,
  //     title: 'done',
  //     text: this.liveTranslate.lang['File downloaded successfully'] ?? 'File downloaded successfully',
  //     icon: 'success',
  //   });
  // }

  blobToBase64(blob: any): any {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
}

export interface RequestConfig {
  path: string;
  params?: Record<string, any>;
  isLoad?: boolean;
  useToken?: boolean;
  // useOldData?: string;
  // minutes?: number;
}
